import { render, staticRenderFns } from "./IntegrationItemGrossPriceWindow.vue?vue&type=template&id=52a85e62&scoped=true&"
import script from "./IntegrationItemGrossPriceWindow.vue?vue&type=script&lang=js&"
export * from "./IntegrationItemGrossPriceWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a85e62",
  null
  
)

export default component.exports